import { Component, computed, inject, OnDestroy } from '@angular/core';
import { FeatureListComponent } from '@core/feature-preview/dialog/components/feature-list.component';
import { FeatureService } from '@core/feature-preview/helpers/feature.service';
import {
  ButtonComponent,
  DialogRefService,
  PlainButtonComponent,
} from '@group24ag/flowkit';
import { FeatureCenterService } from '@core/feature-preview/dialog/services/feature-center.service';
import { FeatureKey } from '@core/feature-preview/types/feature-key';

@Component({
  providers: [FeatureCenterService],
  imports: [FeatureListComponent, ButtonComponent, PlainButtonComponent],
  template: `
    <div class="base--bg flex size-full max-h-full flex-col overflow-hidden">
      <app-feature-list
        class="content--bg flex h-full min-h-0 flex-col px-2.5" />

      <div
        class="element--contrast-bg element--border flex w-full items-center justify-between gap-x-3 border-t px-5 py-3">
        <div class="text--contrast-lowest text-sm font-medium text-nowrap">
          <span> Features enabled: </span>

          <span class="text--contrast-high font-semibold">
            {{ enabledFeatures() }}
          </span>

          <span> of </span>

          <span class="text--contrast-high font-semibold">
            {{ totalFeatures() }}
          </span>
        </div>

        <div class="flex gap-x-3 px-0.5">
          <button flkPlainButton (click)="onCancel()">Close</button>

          <button
            flkButton
            appearance="primary"
            variant="accent"
            [disabled]="!dirty()"
            (click)="onSave()">
            Save
          </button>
        </div>
      </div>
    </div>
  `,
})
export class FeatureCenterDialogComponent implements OnDestroy {
  /** INJECTIONS **/
  /****/
  private readonly featureService = inject(FeatureService);

  /****/
  private readonly centerService = inject(FeatureCenterService);

  /** Holds the reference to the dialog ref **/
  private readonly dialogRef = inject(DialogRefService);

  /** PROPERTIES **/
  /****/
  protected readonly dirty = this.centerService.dirty;

  /****/
  protected readonly totalFeatures = computed(
    () => this.centerService.totalFeatureCount
  );

  /****/
  protected readonly enabledFeatures = computed(
    () => this.centerService.enabledFeatureCount
  );

  ngOnDestroy() {
    this.centerService.resetChanges();
  }

  protected onSave() {
    Object.entries(this.centerService.changes()).forEach(([name, action]) => {
      switch (action) {
        case 'disabled':
          this.featureService.disableFeature(name as FeatureKey);
          break;
        case 'enabled':
          this.featureService.enableFeature(name as FeatureKey);
          break;
      }
    });
    this.centerService.resetChanges();

    this.dialogRef.close(true);
  }

  protected onCancel() {
    this.dialogRef.close(false);
  }
}
